const state = {
    relationship: [
        {
            profile: { name: 'Isabela Moura de Andrade', office: 'Analista Suporte ao cliente', text: '"Trabalhar no grupo Travelex Confidence é ter orgulho, é vestir a camisa e sentir paixão todos os dias pelo que faço. O amor ao trabalho, da sentido a ele e faz com que a vontade de fazer o melhor venha de dentro, proporcionando aos clientes experiências incríveis."' },
            icon: require('@/views/home/assets/images/values/isabela.png'),
            banner: require('@/views/home/assets/images/values/foto-isabela.png')
        },
        {
            profile: { name: 'Catiane Santos Loschiavo', office: 'Gerente de Monitoramento', text: '"O clima da empresa proporciona um bom engajamento interpessoal, com pilares importantes como comunicação, respeito, profissionalismo, comprometimento e confiança mútua."' },
            icon: require('@/views/home/assets/images/values/catiane.png'),
            banner: require('@/views/home/assets/images/values/foto-catiane.png')
        },
        {
            profile: { name: 'Felipe Perazza Costa e Silva', office: 'Gerente de Comunicação e Marketing', text: '"Sinto que no Grupo Travelex Confidence temos um ambiente que valoriza novas ideias e soluções que otimizam o trabalho e os resultados. Para quem quer contribuir, há espaço não apenas para trabalhar, mas também para aprender e crescer. E o melhor: em um ambiente acolhedor e de respeito"' },
            icon: require('@/views/home/assets/images/values/felipe.png'),
            banner: require('@/views/home/assets/images/values/foto-felipe.png')
        },
        {
            profile: { name: 'Jefter de Oliveira Carvalho', office: `Gerente Especialista de Cambio`, text: `"Trabalhar no Grupo Travelex é uma experiência única. Cada dia que passa aprendo mais, não só sobre câmbio, mas também como colocar o cliente no centro de tudo, entendendo suas necessidades para melhor atende-lo. Para mim é uma honra fazer parte desse grupo."` },
            icon: require('@/views/home/assets/images/values/jefter.png'),
            banner: require('@/views/home/assets/images/values/foto-jefter.png')
        },
        {
            profile: {
                name: 'Karen Maeda', office: `Gerente Jurídico`, text: `“Entrei no Grupo Travelex Confidence na semana em que foi decretada a pandemia no Brasil. Conheci meus colegas de trabalho por vídeo, e é muito bom quando os encontro presencialmente no escritório. O que mais me surpreende aqui, é a preocupação em proporcionar ao cliente uma experiência única de atendimento, facilidade e segurança nos serviços.
            E o cliente pode ser todo mundo, inclusive nós!
            Me orgulho de fazer parte da maior empresa de câmbio do mundo!”` },
            icon: require('@/views/home/assets/images/values/karen.png'),
            banner: require('@/views/home/assets/images/values/foto-karen.png')
        },
        {
            profile: {
                name: 'Lorenzo Garcia Santana ', office: `Consultor de Núcleo de Negócios`, text: `"Quando consegui e tão sonhada entrevista, não obtive êxito no processo seletivo, o que me fez refletir em mudar meus objetivos por não ter conseguido o que tanto almejava. Contudo, meses depois fui convocado para uma nova entrevista, onde fiquei encantado com o ambiente de trabalho e toda infraestrutura fornecida aos colaboradores no novo escritório. Depois de tanto tempo e com muitas incertezas, meu "sim" finalmente chegou. Foi um alivio com sentimento de conquista pessoal e profissional. Iniciei na Travelex Confidence e aprendi a me desenvolver a cada dia. Foi enriquecedor e me proporcionou hoje estar no Travelex Bank, atuando como consultor. Hoje olho para trás com o sentimento de gratidão e orgulho em pertencer ao Grupo."`
            },
            icon: require('@/views/home/assets/images/values/lorenzo.png'),
            banner: require('@/views/home/assets/images/values/foto-lorenzo.png')
        },
        {
            profile: {
                name: 'Ricardo Antonio Resende', office: `Gerente de Logística e Segurança Patrimonial `, text: `"Estou há dez anos na instituição e só a vi crescer!
            Uma instituição séria e focada nos resultados dando oportunidades para as áreas que necessitaram dessa demanda.
            Uma empresa que, durante a pandemia, esteve junto dos funcionários e que deu todo respaldo necessário para que pudéssemos exercer nossas funções, cada um em sua casa!"` },
            icon: require('@/views/home/assets/images/values/ricardo.png'),
            banner: require('@/views/home/assets/images/values/foto-ricardo.png')
        },
        {
            profile: { name: 'Michel George de Menezes Correa', office: `Gerente de Auditoria`, text: `"Fazer parte do time do Grupo Travelex Confidence me traz gratidão, orgulho e me proporciona todos os elementos para ser um profissional de sucesso. Somos desafiados diariamente a sermos melhores, assumindo a postura de protagonista para vencer obstáculos, propor projetos e ter a ousadia de buscar os resultados. Além disso, fazer parte do maior especialista em câmbio me permite acesso a profissionais, processos e práticas de mercado do mundo todo, como também a oportunidade de poder participar de trabalhos de auditoria globais."` },
            icon: require('@/views/home/assets/images/values/michel.png'),
            banner: require('@/views/home/assets/images/values/foto-michel.png')
        },
        {
            profile: { name: 'Ana Gizele Costa de Oliveira', office: `Coordenadora de Conciliação`, text: `"Iniciei minha carreira profissional no Travelex em 2017 como Jovem Aprendiz auxiliando nas demandas do BackOffice de câmbio, era meu primeiro emprego. Em 2019 tive minha efetivação como estagiária e nesse mesmo ano fui promovida a Analista no Middle office.  Aprendi, amadureci, cresci, e para isso acontecer teve uma gama enorme de fatores, sou grata por todos eles, me orgulho em ver o quanto o grupo cresceu e em como promove o crescimento das pessoas. O ambiente de trabalho aqui nos proporciona uma vontade de sempre querer saber mais, nos capacita e ajuda a mantermos o equilíbrio na nossa vida! Esse ano cheguei ao nível de gestão, atuou como Coordenadora de Conciliação."` },
            icon: require('@/views/home/assets/images/values/ana_gizele.png'),
            banner: require('@/views/home/assets/images/values/foto-ana_gizele.png')
        },
    ],
    areas: [
        {
            id: '2884',
            title: `Tecnologia`,
            text: `Responsáveis pela segurança da informação, desenvolvimento de sistemas, produção, infraestrutura e arquitetura de dados, nossos profissionais de tecnologia são essenciais para o crescimento exponencial e sustentável da companhia com soluções inovadoras e seguras para todos.`,
            banner: require('@/views/home/assets/images/areas/img-area-tecnologia-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-tecnologia.png')
        },
        {
            id: '2885',
            title: `Comercial (Banco)`,
            text: `​Temos orgulho de ser o primeiro banco do país, registrado e aprovado pelo Banco Central do Brasil, a operar exclusivamente em câmbio.  ​
            No Comercial do Travelex Bank, temos uma equipe de especialistas de sucesso pronta para buscar as melhores soluções para os nossos clientes em todo territorio nacional.
            `,
            banner: require('@/views/home/assets/images/areas/img-area-comercial-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-comercial.png')
        },
        {
            id: '2882',
            title: `Varejo`,
            text: `Com mais de 100 lojas no Brasil e atendimento pelo telefone, chat, e-mail e WhatsApp, o Varejo do Grupo Travelex Confidence oferece o portfólio mais completo de Produtos e Serviços em Câmbio para os nossos clientes.​
            Aqui, participamos da realização dos sonhos de muita gente!​
            `,
            banner: require('@/views/home/assets/images/areas/img-area-varejo-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-varejo.png')
        },
        {
            id: '2993',
            title: `PLD, Compliance e Cadastro`,
            text: `A nossa empresa atua ativamente na luta contra a lavagem de dinheiro por entender que esse crime viola os direitos humanos e a ética dos negócios em escala global. É responsabilidade de todos nós garantir a integridade das operações realizadas pelo Grupo Travelex Confidence. As áreas de PLD, Compliance e Cadastro reafirmam a forma correta de agir e pensar no ambiente de trabalho, não ferindo as operações e a conduta ética e profissional da empresa, com o objetivo de prevenir crimes de fraude, lavagem de dinheiro e o financiamento do terrorismo nas operações de câmbio.`,
            banner: require('@/views/home/assets/images/areas/img-area-pld-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-pld.png')
        },
        {
            id: '2886',
            title: `Riscos e Financeiro`,
            text: `O time de Finanças tem atuação central com informações e análises precisas que permitem que estratégias sejam traçadas. Somos agentes ativos na administração dos recursos financeiros do Grupo garantindo sua competitividade e integridade.A área de Riscos também faz parte da estrutura de Finanças. Um time que zela pela integridade e sustentabilidade dos negócios e previne prejuízos pela mitigação do risco.`,
            banner: require('@/views/home/assets/images/areas/img-area-riscos-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-riscos.png')
        },
        {
            id: '2881',
            title: `Operações e Tesouraria`,
            text: `A área de Operações é o coração do banco. Temos processos de classe mundial e atuamos para que cada operação seja efetivada com agilidade e segurança para os nossos clientes. As equipes do Middle Office, Back Office e Tesourarias atuam em sinergia com foco na integridade e compliance dos nossos negócios.`,
            banner: require('@/views/home/assets/images/areas/img-area-operacoes-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-operacoes.png')
        },
        {
            id: '2876',
            title: `Marketing`,
            text: `Nosso time de Marketing realiza diversos estudos de comportamento e de mercado para podermos elaborar estratégias de comunicação efetivas para atender nossos atuais e futuros clientes para além de suas necessidades. A área dá suporte na elaboração de campanhas de vendas, internas, materiais promocionais e comerciais, conquistando espaços estratégicos na mídia para sustentar a reputação da nossa marca.`,
            banner: require('@/views/home/assets/images/areas/img-area-mkt-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-mkt.png')
        },

        {
            id: '2883',
            title: `Digital e Produtos`,
            text: `O time de Digital trabalha para oferecer a melhor experiência digital para os nossos clientes de forma ágil, tendo foco no resultado: performance SEO, usabilidade, engajamento e experiência positiva com a marca. A inovação está no nosso DNA, criamos sempre novas oportunidades de negócios e atuamos na transformação digital da empresa. O time de Produtos é responsável pela gestão e desenvolvimento do portfólio de produtos, ajudando a empresa a entregar aquilo que o nosso cliente precisa. Além disso, temos uma grande responsabilidade, garantir que os processos internos aconteçam de forma rápida e seguindo a governança.`,
            banner: require('@/views/home/assets/images/areas/img-area-digital-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-digital.png')
        },
        {
            id: '2887',
            title: `Recursos Humanos`,
            text: `A equipe de RH trabalha para criar um ambiente e uma cultura que engaja e desenvolve talentos. Ofereceremos oportunidades de reconhecimento e crescimento para que cada colega faça o seu melhor. Desta forma, apoiamos e possibilitamos que as ambições e demandas do negócio, em suas especificidades, sejam atendidas agora e no futuro.`,
            banner: require('@/views/home/assets/images/areas/img-area-rh-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-rh.png')
        },
        {
            id: '2877',
            title: `Jurídico`,
            text: `O nosso time de advogados provê serviços jurídicos de altíssima qualidade para o negócio. E, ainda temos suporte para o desenvolvimento de cada colaborador nas questões específicas do nosso segmento de mercado. Temos orgulho de ser especialistas e transmitir confiança.`,
            banner: require('@/views/home/assets/images/areas/img-area-juridico-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-juridico.png')
        },
        {
            id: '2988',
            title: `Auditoria`,
            text: `Nosso departamento de Auditoria é comprometido com a qualidade e a segurança de nossos serviços e processos em acordo com os órgãos reguladores, garantindo a sustentabilidade do Grupo. Optar por uma carreira na área de auditoria significa cercar-se de grande responsabilidade, normas profissionais e metodologia de trabalho.`,
            banner: require('@/views/home/assets/images/areas/img-area-auditoria-banner.png'),
            thumb: require('@/views/home/assets/images/areas/img-area-auditoria.png')
        },
    ],
    benefits: [
        {
            icon: require('@/views/home/assets/images/benefits/1.svg'),
            title: `Vale Refeição`
        },
        {
            icon: require('@/views/home/assets/images/benefits/2.svg'),
            title: `Vale Alimentação`
        },
        {
            icon: require('@/views/home/assets/images/benefits/3.svg'),
            title: `Vale Cultura`
        },
        {
            icon: require('@/views/home/assets/images/benefits/4.svg'),
            title: `Auxílio Creche ou Babá`
        },
        {
            icon: require('@/views/home/assets/images/benefits/5.svg'),
            title: `Seguro de Vida`
        },
        {
            icon: require('@/views/home/assets/images/benefits/6.svg'),
            title: `Assistência Médica`
        },
        {
            icon: require('@/views/home/assets/images/benefits/7.svg'),
            title: `Assistência Odontológica`
        },
        {
            icon: require('@/views/home/assets/images/benefits/8.svg'),
            title: `Empréstimo Consignado`
        },
        {
            icon: require('@/views/home/assets/images/benefits/9.svg'),
            title: `Participação nos lucros e resultados`
        },
        {
            icon: require('@/views/home/assets/images/benefits/10.svg'),
            title: `Horário Flexível`
        },
        {
            icon: require('@/views/home/assets/images/benefits/11.svg'),
            title: `Desconto em produtos da empresa`
        },
        {
            icon: require('@/views/home/assets/images/benefits/12.svg'),
            title: `Desconto em produtos de parceiros`
        },
        {
            icon: require('@/views/home/assets/images/benefits/13.svg'),
            title: `Creditas`
        },
        {
            icon: require('@/views/home/assets/images/benefits/14.svg'),
            title: `GymPass`
        },
        {
            icon: require('@/views/home/assets/images/benefits/15.svg'),
            title: `ApoioPass`
        },
        {
            icon: require('@/views/home/assets/images/benefits/16.svg'),
            title: `Univers (Farmácia)`
        },
        {
            icon: require('@/views/home/assets/images/benefits/17.svg'),
            title: `Parcerias para bem estar`
        },
        {
            icon: require('@/views/home/assets/images/benefits/18.svg'),
            title: `Descontos em instituições educacionais`
        },
    ]
}

export { state }